export class Categoria {
	id: String = "";
	nombre: String = "";
	status: String = "";
	usuario_id: String = "";
	empresa_id: String = "";

	constructor(data?: ICategoria) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(data?: any) {
        if (data) {
            this.id = data["id"];
			this.nombre = data["nombre"];
			this.status = data["status"];
			this.empresa_id = data["empresa_id"];
            this.usuario_id = data["usuario_id"];
		}
    }

    static fromJS(data: any): Categoria {
        let result = new Categoria();
        result.init(data);
        return result;
    }

}
export class ICategoria {
	id: String;
	nombre: String;
	status: String;
	usuario_id: String;
	empresa_id: String;
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/categoria.ts